module.exports = __webpack_public_path__ + "static/media/logo.370f4d14.png";